import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-importExportDataResponse-dialog',
  templateUrl: './importExportDataResponse-dialog.component.html',
  styleUrls: ['./importExportDataResponse-dialog.component.css']
})
export class ImportExportDataResponseDialogComponent implements OnInit {
  TAG = "ApiResultDialogComponent";
  // displayMsg: string;
  @Input() action: string;
  @Input() status: string;
  @Input() tableKeyValue: string;
  @Input() msg: string;
  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
  }

}
